let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5cAsx")).then(() => parcelRequire('5pE8G'));